<template lang="html">
    <div class="search-helper-comp__table--field search-helper-table">
        <div v-for="item in searchFieldList" :key="item.id" :class="{'search-helper-table__current': currentNav === item.nav}">
            <div  class="search-helper-table__title" :id="item.id">{{item.label}}</div>
            <table class="splitFourTds">
                <thead>
                <tr>
                    <td>{{$t('searchHelper["Field Abbreviation"]')}}</td>
                    <td>{{$t('searchHelper["Field Name"]')}}</td>
                    <td>{{$t('searchHelper["Type"]')}}</td>
                    <td>{{$t('searchHelper["Example and Comments"]')}}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="subItem in item.fields" :key="subItem.key">
                    <td>{{ subItem.key }}</td>
                    <td>{{subItem.desc}}</td>
                    <td>{{ $t(`searchHelper['${subItem.type}']`) }}</td>
                    <td>
                        <div v-html="subItem.mainTip"  />
                        <p v-if="subItem.fullTip" class="desc" v-html="subItem.fullTip"></p>
                    </td>
                    <!-- <td v-else v-html="$t(`searchHelper['${subItem.example}']`)" /> -->
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { fieldData } from '../src/fieldData';
import { computed, onMounted, ref, defineProps, defineEmits } from 'vue';
import { useI18n } from '@/composables/useI18n';
import VueI18n from 'vue-i18n';

interface IField {
    key: string;
    type: string;
    desc?: string;
    mainTip?: string;
    fullTip?: string;
}

interface ISearchField {
    id: string;
    label: VueI18n.TranslateResult;
    nav: string;
    fields: IField[];
}

const deleteSearchFields = ['TTL_JPTRANS', 'ABST_JPTRANS', 'CLMS_JPTRANS', 'DESC_JPTRANS'];

const { get, filter, includes, map } = _;

const { locale, t } = useI18n();

defineProps<{
    currentNav: string;
}>();

const emit = defineEmits<{(e: 'update-nav-handler', value: ISearchField[]): void,
}>();

const serviceArea = get(window, 'zPREFACE.accountInfo.site_region', 'CN');

const searchFields = ref<ISearchField[]>([]);

const searchFieldList = computed(() => {
    if (serviceArea === 'CN' && searchFields.value[0]) {
        var after = filter(searchFields.value[0].fields, item => !includes(deleteSearchFields, item.key));
        searchFields.value[0].fields = after; //eslint-disable-line
    }
    return searchFields.value;
});

onMounted(async () => {
    const { searchHelperFieldData } = await import('library-@/AdvancedSearchForm/constants/fieldDataMap');
    const data = map(fieldData, item => {
        const fields = map(item.fields, subItem => {
            const desc = get(searchHelperFieldData, `${subItem.key}.desc.${locale}`);
            const mainTip = `${subItem.key === 'CCF_' ? 'CCF_PR' : subItem.key}:${get(searchHelperFieldData, `${subItem.key}.mainTip.${locale}`)}`;
            const fullTip = get(searchHelperFieldData, `${subItem.key}.fullTip.${locale}`);
            subItem = {
                ...subItem,
                desc,
                mainTip,
                fullTip,
            };
            return subItem;
        });
        return {
            fields,
            id: item.id,
            nav: `#${item.id}`,
            label: t(`searchHelper['title_${item.type}']`),
        };
    });
    searchFields.value = data;
    emit('update-nav-handler', searchFields.value);
});
</script>

<style lang="scss">
.search-helper-comp__table--field {
  .desc {
    font-size: 12px;
    color:#1D8820;
    line-height: 16px;
  }
}
</style>
